var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00176 10.9012C0.768107 10.9015 0.541671 10.8383 0.361759 10.7225C0.260501 10.6572 0.176799 10.5771 0.115447 10.4867C0.0540955 10.3963 0.0162993 10.2974 0.00422342 10.1956C-0.00785243 10.0938 0.00602957 9.99122 0.045074 9.89362C0.0841184 9.79602 0.147557 9.70537 0.231759 9.62685L4.71175 5.46195L0.39176 1.28928C0.308694 1.2098 0.246662 1.11835 0.209231 1.02018C0.171799 0.922008 0.159705 0.819058 0.173644 0.717244C0.187583 0.615431 0.22728 0.516762 0.290454 0.426908C0.353628 0.337055 0.439033 0.257789 0.541759 0.193666C0.645225 0.122927 0.76639 0.0695704 0.897652 0.0369435C1.02891 0.00431662 1.16744 -0.00687553 1.30453 0.0040689C1.44162 0.0150133 1.57433 0.0478583 1.69431 0.100543C1.81429 0.153227 1.91896 0.224613 2.00176 0.310221L6.83175 4.97242C6.97883 5.11146 7.05923 5.28586 7.05923 5.46584C7.05923 5.64582 6.97883 5.82021 6.83175 5.95925L1.83176 10.6214C1.73144 10.7155 1.60401 10.7898 1.4598 10.8384C1.31559 10.887 1.15866 10.9085 1.00176 10.9012Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.795335ca581430c0f953c7b46d3624d4.svg";
export { ForwardRef as ReactComponent };